module.exports = __webpack_public_path__ + "static/media/no-data.1537e7c9.svg";